import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/icon/close-share.svg")